import {t} from "../../i18n";

import './AllianceBar.css';
import {ReactNode} from "react";

export default function AllianceBar({seed, alliance, caption, color, winCount, compressed, vertical, teamsBeforeSeed, teamCount, withAvatar} : {
    seed?: ReactNode,
    alliance?: { displayNumber: string }[] | ReactNode[],
    caption?: boolean,
    color?: 'red' | 'blue' | 'orange' | 'grey',
    winCount?: ReactNode,
    compressed?: boolean,
    vertical?: boolean,
    teamsBeforeSeed?: boolean,
    teamCount?: number,
    withAvatar?: boolean
}) {
    if(caption) {
        alliance = teamCount == 3 ? [t`Captain`, t`1st Pick`, t`2nd Pick`] : [t`Captain`,  t`Partner`]
    }
    if(!alliance) {
        alliance = ['']
    }

    const teams = teamCount || 3
    const allianceElements = alliance.slice(0, teams).map((team, idx) => {
        if(!team) return <span key={idx} className={"allianceTeamNumber"}>&nbsp;</span>;
        const teamStr = typeof team == "object" && "displayNumber" in team ? team.displayNumber : team;
        return <span key={idx} className={`allianceTeamNumber ${withAvatar ? 'withAvatar' : ''}`}>{withAvatar ? <span className={`team-avatar team-${teamStr}`}></span> : null}<span className={"numberText"}>{teamStr}</span></span>
    })
    const seedElement = seed || caption ? <span key={"seed"} className={`seed ${typeof seed == 'string' ? '' : 'big'}`}>{seed}</span> : null;
    const teamsElement = <div key={"teams"} className={"teamsWrapper"}>{allianceElements}</div>;
    const teamAndSeed = teamsBeforeSeed ? [teamsElement, seedElement] : [seedElement, teamsElement];
    return <div className={`allianceBar alliance${seed} ${caption ? 'caption' : ''} ${color || ''} ${compressed ? 'compressed' : ''}`} style={{'--team-count': teams}}>
        {vertical ? <div className={"verticalContainer"}>{teamAndSeed}</div> : teamAndSeed}
        {winCount != null? <span className={"winCount"}>{winCount}</span> : null}
    </div>;
}